import * as React from 'react';
import { GatsbySeo } from 'gatsby-plugin-next-seo';
import PropTypes from 'prop-types';

import { useThemeContext } from '../hooks';
import { Topbar } from './topbar';
import { Header } from './header';
import { BackToTop } from './back-to-top';
import { Footer } from './footer';
import { BottomBar } from './bottom-bar';

function Layout({ children }) {
  const { theme } = useThemeContext();

  return (
    <>
      <GatsbySeo
        titleTemplate="%s | GLF Online"
        description="Dedicated entirely to womens and mens golfing and clothing needs with personalised service and brands like Nivo and Jamie Sadock, our online golf store has the largest product range and excellent service."
        canonical="https://www.glfonline.com.au/"
        openGraph={{
          url: 'https://www.glfonline.com.au',
          title: 'GLF Online',
          description:
            'Dedicated entirely to womens and mens golfing and clothing needs with personalised service and brands like Nivo and Jamie Sadock, our online golf store has the largest product range and excellent service.',
          site_name: 'GLF',
        }}
      />

      <div
        data-theme={theme}
        id="top"
        className="flex flex-col w-full min-h-screen mx-auto font-sans antialiased text-black bg-white max-w-7xl"
      >
        <Topbar />
        <Header />
        <main className="flex-1">{children}</main>
        <Footer />
        <BackToTop />
        <BottomBar />
      </div>
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export { Layout };
